<template>
    <div class="component__view">
        <div class="title"></div>


        <div class="pack-type flex-between-center">
            <div class="pack-item u-btn p-1" :class="{'active' : active_index == 0}" @click="active_index = 0"></div>
            <div class="pack-item u-btn p-2" :class="{'active' : active_index == 1}" @click="active_index = 1"></div>
            <div class="pack-item u-btn p-3" :class="{'active' : active_index == 2}" @click="active_index = 2"></div>
            <!-- <div class="pack-item u-btn p-4" :class="{'active' : active_index == 3}" @click="active_index = 3"></div> -->
        </div>


        <div class="pack-pannel">

            <Transition name="slide-fade" mode="out-in">
            <div class="pack-view" :key="active_index" v-if="ready">
                <div class="pack-name needLang ali"><!--<em class="icon-pack"></em>-->{{ pack_title[active_index] }}</div>
                <div class="pack-intro needLang hyz">{{ config[(active_index + 1)].amt }}梦币带走{{ config[(active_index + 1)].cnt }}件自选道具</div>

                <div class="pack-body">
                    <div class="pack-select flex-center-start flex-wrap">
                        <div class="goods-item" v-for="(item,index) in config[(active_index + 1)].list" :key="index" @click.stop="put_in(active_index,item)">
                            <div class="icon-wrapper"
                            :class="{'active' : in_basket(active_index, item)}">
                                <div class="reward-pic" v-tips="item.gameGiftId"><game-item :locked="true" :id="item.gameGiftId" :num="item.sendNum"></game-item></div>
                            </div> 
                            
                            <div class="radio" :class="{'active' : in_basket(active_index, item)}">
                                <div class="active-dot"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="result-view">
                    <div class="slogen-result"></div>

                    <div class="result-list flex-center-start flex-wrap">

                        <div class="goods-item" v-for="(item,index) in gids[active_index]" :key="item.id">
                            <div class="icon-wrapper active">
                            <div class="reward-pic" v-tips="item.gameGiftId"><game-item :locked="true" :id="item.gameGiftId" :num="item.sendNum"></game-item></div>
                            </div> 
                            
                            <div class="btn-del" @click="delete_item(active_index,item)"></div>
                        </div>                    

                        <div class="goods-item" v-for="n in (config[(active_index + 1)].cnt - gids[active_index].length)" :key="n">
                            <div class="icon-wrapper">
                                <div class="reward-pic"></div>
                            </div> 

                            <div class="radio"></div>
                        </div>
                    </div>
                </div>

                <div class="price-view">
                    <div class="price">打包价<b>{{ config[(active_index + 1)].amt }}</b><em class="icon-m3b"></em></div>
                    <div class="u-btn apply" 
                    @click="call_comfirm({ cost : config[(active_index + 1)].amt , giftName : pack_title[active_index] , id : (active_index + 1) , list : gids[active_index]})" 
                    :class="{'disabled' : gids[active_index].length < config[(active_index + 1)].cnt}"
                    ></div>
                    <div class="buy-cnt">当前已购买  {{ config[(active_index + 1)].buyCount }} / {{ config[(active_index + 1)].limit }} 次</div>
                </div>
            </div>
            </Transition>
        </div>
    </div>
</template>

<script>
import {
    apiPackConfig,
} from '@/api/index';

export default {
    data(){
        return {
            gids : [
                [],
                [],
                [],
                [],
            ],
            ready : false,
            active_index : 0,
            pack_title : ['超值自选库','进阶自选库','高级自选库','至臻自选库',],
            config : {},
        }
    },
    computed :{
        _zid (){
            return this.$store.state.userinfo.zid;
        },
        _pack (){
            return this.$store.state.pack;
        },           
    },
    watch : {
        _pack : {
            handler(newVal, oldVal) {
                if(newVal != oldVal){
                    //this.init();
                    this.config = newVal;
                }              
            },           
        },
        _zid : {
            handler(newVal, oldVal) {
                if(!this.$store.state.userinfo.zid)return;
                if(newVal != oldVal){
                    this.init();
                }              
            },           
        },                                       
    },         
    mounted(){
        this.init();
    },
    methods : {
        init(){
            apiPackConfig().then(
                res => {
                    this.config = res.data;
                    this.ready = true;
                    this.$store.commit("$_setPack", res.data);
                },
            )
        },
        put_in(x,item){
            this.in_basket(x,item) ? this.delete_item(x,item) : (this.gids[x].length >= this.config[(x + 1)].cnt ? this.$toast('超过最大选取道具数量') : this.gids[x].push(item));            
        },
        delete_item(x,item){
            let index = this.gids[x].findIndex(ele => item.id == ele.id);
            console.log(x)
            this.gids[x].splice(index, 1);
        },
        in_basket(x,item){
            //todo
            let index = this.gids[x].findIndex(ele => item.id == ele.id);
            return index != -1;
        },
        call_comfirm(config){
            //todo

            if(this.gids[this.active_index].length < this.config[(this.active_index + 1)].cnt )return;
            this.$pack_comfirm(config);
        },
    },
}
</script>

<style lang="scss" scoped>
.component__view{
    width: 750px;
    height: 1491px;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-position: center top;
    box-sizing: border-box;
    background-image: url(~@/assets/images/select/body.jpg);    
}

.title{
    width: 711px;
    height: 230px;
    margin: 0 auto 30px;
    background-image: url(~@/assets/images/select/title.png); 
}

.pack-type{
    width: 710px;
    margin: 0 auto 36px;
}

.pack-item{
    width: 219px;
    height: 100px;

    @for $i from 1 through 4 {
        &.p-#{$i} {
            background-image: url(~@/assets/images/select/pack-#{$i}.png);

            &.active{
                background-image: url(~@/assets/images/select/pack-#{$i}a.png);
            }
        }
    }        
}


.pack-pannel{
    position: relative;
    width: 710px;
    height: 920px;
    padding: 17px 20px 0;
    margin: 0 auto 0;
    background-image: url(~@/assets/images/select/pannel.png);
}

.pack-view{
    height: 100%;
    margin-top: 18px;

    .pack-body{
        height: 290px;
    }

    .pack-name{
        width: 606px;
        height: 53px;
        line-height: 53px;
        margin: 0 auto 37px;
        text-align: center;
        font-size: 36px;
        color: #d74e34;
        background-image: url(~@/assets/images/select/bg-bag-name.png);

        .icon-pack{
            display: inline-block;
            vertical-align: middle;
            width: 43px;
            height: 51px;
            background-image: url(~@/assets/images/select/icon-pack.png);
        }
    }

    .pack-intro{
        text-align: center;
        font-size: 22px;
        color: #a48971;
    }

    .pack-select{
        margin-top: 30px;
        // padding: 0 13px;
    }

    .goods-item{
        height: 135px;
        margin: 0 6px 14px;
        cursor: pointer;
    }

    .icon-wrapper{
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        padding: 12px;
        border: 3px solid #dbd3c6;
        border-radius: 5px;
        transition: all .4s cubic-bezier(0.075, 0.82, 0.165, 1);
        box-sizing: border-box;

        &.active{
            border-color: #f5c2ad;
        }

        .reward-pic{
            width: 69px;
            height: 69px;
            background-color: #fdf5da;
        }
    }

    .radio{
        position: relative;
        width: 34px;
        height: 34px;
        margin: -10px auto 0;
        border: 3px solid #dbd3c6;
        border-radius: 50%;
        background-color: #faf1e1;
        
        .active-dot{
            position: absolute;
            left: 50%;
            top: 50%;
            width: 21px;
            height: 18px;
            margin: -9px 0 0 -10.5px;
            transform: scale(0);
            transition: all .4s ease-in-out;
            background-image: url(~@/assets/images/select/icon-this.png);
        }

        &.active{
            border-color: #f5b29b;

            .active-dot{
                transform: scale(1);
            }
        }
    }
}

.result-view{
    margin-top: 16px;

    .slogen-result{
        width: 526px;
        height: 31px;
        margin: 0 auto 14px;
        background-image: url(~@/assets/images/select/result.png);
    }

    .btn-del{
        width: 34px;
        height: 34px;
        margin: -10px auto 0;
        background-image: url(~@/assets/images/select/btn-del.png);
    }
}

.price-view{
    margin-top: -10px;
    text-align: center;

    .price{
        font-size: 22px;
        color: #666666;
        font-weight: 700;

        b{
            font-size: 58px;
            color: #e8533d;
        }
    }

    .u-btn.apply{
        width: 235px;
        height: 75px;
        margin: 0 auto;
        background-image: url(~@/assets/images/select/btn-apply.png);
    }

    .buy-cnt{
        margin-top: 16px;
        font-size: 22px;
        color: #908f8e;
    }
}
</style>